import { scaleBand } from '@visx/vendor/d3-scale';
import scaleOperator from "../operators/scaleOperator.js";
export const updateBandScale = scaleOperator('domain', 'range', 'reverse', 'align', 'padding', 'round');
export default function createBandScale(config) {
  return updateBandScale(scaleBand(), config);
}